import React from 'react';

interface Props {
    isSale: number
    isNovelty: boolean
    isMedical: boolean
}

export class IsMedicalIsNoveltyIsSale extends React.Component<Props, {}> {


    componentDidMount() {
    }

    render() {

        let isSale: number = this.props.isSale
        let isNovelty: boolean = this.props.isNovelty
        let isMedical: boolean = this.props.isMedical

        return (
            <>
                {isSale ? <span className="med-sticker">{Math.round(isSale)}%</span> : null}
                {isNovelty ? <span className="blue-sticker">Новинка</span> : null}
                {isMedical ? <span className="med-sticker">Мед</span> : null}

            </>
        )
    }
}

